module.exports = __webpack_public_path__ + "static/media/maimai_seminyak.a5aafc19.jpg";